import './ReferenceCount.scss';

import { COPY_GENERIC } from '@sonar-software/sonar-ts-constants';
import { debounce } from 'lodash';
import { FilterComponent } from './FilterComponent';
import { usePrevious } from '@hooks';

import { Flex, InputNumber } from 'antd';
import React, { useCallback, useEffect, useMemo, useState } from 'react';

export const ReferenceCountFilter: FilterComponent<[number | null, number | null, boolean] | null> = (props) => {
	const { format, id, onChange, value, label } = props;
	const startValue = value?.[ 0 ] || value?.[ 1 ] ? 0 : null;
	const endValue = value?.[ 1 ] ?? null;
	const [ displayRange, setDisplayRange ] = useState([ startValue, endValue ]);
	const showClearButton = value?.[ 0 ] || value?.[ 1 ];
	const previousValue = usePrevious(value);

	useEffect(() => {
		if (value?.[ 0 ] !== previousValue?.[ 0 ] || value?.[ 1 ] !== previousValue?.[ 1 ]) {
			const start = value?.[ 0 ] ?? null;
			const end = value?.[ 1 ] ?? null;

			setDisplayRange([ start, end ]);
		}
	}, [ previousValue, value ]);

	const debouncedOnChange = useMemo(
		() => debounce((start: number | null, end: number | null) => {
			setDisplayRange([ start, end ]);

			onChange({
				[ id ]: {
					format,
					value: start || end ? [ start, end, true ] : null
				}
			});

		}, 300, { leading: false }),
		[ format, id, onChange ]
	);

	const handleChangeStart = useCallback((start: number | null) => {
		const [ , end ] = displayRange;
		const validEnd = start && end !== null && start > end ? null : end;

		setDisplayRange([ start, end ]);
		debouncedOnChange(start, validEnd);
	}, [ debouncedOnChange, displayRange ]);

	const handleChangeEnd = useCallback((end: number | null) => {
		const [ start ] = displayRange;
		const validStart = start && end !== null && start > end ? null : start;

		setDisplayRange([ start, end ]);
		debouncedOnChange(validStart, end);
	}, [ debouncedOnChange, displayRange ]);

	const tagLabelStart = displayRange[ 0 ] ?? 0;
	const tagLabelEnd = (displayRange[ 1 ] ?? 0) > 0 ? ` - ${displayRange[ 1 ]}` : '+';

	return (
		<FilterComponent
			{ ...props }
			className='reference-count-filter'
			tagProps={ {
				label,
				value: showClearButton ? `${tagLabelStart}${tagLabelEnd}` : null
			} }>
			<Flex
				align='center'
				gap={ 16 }>
				{ COPY_GENERIC.FROM }
				<InputNumber
					min={ 0 }
					onChange={ handleChangeStart }
					value={ displayRange[ 0 ] || (displayRange[ 1 ] ? 0 : null) } />
				{ COPY_GENERIC.TO }
				<InputNumber
					min={ 0 }
					onChange={ handleChangeEnd }
					value={ displayRange[ 1 ] || null } />
			</Flex>
		</FilterComponent>
	);
};
